import type { TReportingLog } from 'types/reporting.type';
import { EditableTable } from '@timeedit/ui-components';

const LogItemTable = ({ record }: { record: TReportingLog }) => {
  return (
    <EditableTable
      columns={itemColumns}
      dataSource={record.logs}
      pagination={false}
    />
  );
};

const itemColumns = [
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Message',
    dataIndex: 'message',
    key: 'message',
  },
];

export default LogItemTable;
